import { RootState } from "../reducers"

export const selectMats = (state: RootState) => state.rewards.mats

export const selectTotalMats = (state: RootState) =>
  state.rewards.mats.totalMats

export const selectInactiveMats = (state: RootState) =>
  state.rewards.mats.inactiveMats

export const selectMatsActivated = (state: RootState) =>
  state.rewards.mats.matsActivated

export const selectMatsLoading = (state: RootState) =>
  state.rewards.mats.isLoading
